import {Pipe, PipeTransform} from '@angular/core';
import {NotificationGroupDto} from '../../Models/Notification/notification-groups.interface';
import {NotificationDto} from '../../Models/Notification/notification.interface';

@Pipe({
  name: 'notificationGroups',
  standalone: false
})
export class NotificationGroupsPipe implements PipeTransform {

  transform(items: NotificationGroupDto[], notifications: NotificationDto[]): NotificationGroupDto[] {

    if (!items || items.length === 0 || notifications.length === 0) {
      return [];
    }

    if (notifications && notifications.length > 0) {

      return items.filter((group) => notifications.some((not) => not.id_grupo === group.id));

    }

    return items;

  }

}
